import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from '@/components/ui/card';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import UserForm from '../components/UserForm';

export default function UserComplete() {
	const navigate = useNavigate();
	const { t } = useTranslation();

	return (
		<Card className="mx-auto -mt-9 max-w-sm self-center">
			<CardHeader>
				<CardTitle className="flex items-center text-xl">
					<ArrowLeft
						className="mr-2 h-6 w-6 cursor-pointer"
						onClick={() => navigate('/profile')}
					/>
					{t('user.form.edit.title')}
				</CardTitle>
				<CardDescription>{t('user.form.description')}</CardDescription>
			</CardHeader>
			<CardContent>
				<UserForm onSave={() => navigate('/home')} />
			</CardContent>
		</Card>
	);
}
